module.exports = __webpack_public_path__ + "img/sliders_2-07.451ab202.png";